
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M1005CourseTypeService.M20301_doAdd'},
    getEdit: { api: 'M1005CourseTypeService.M20301_getEdit'},
    doEdit: { api: 'M1005CourseTypeService.M20301_doEdit'},
    // doRead: { api: 'M1005CourseTypeService.M20301_doRead'},
    // doDelete: { api: 'M1005CourseTypeService.M20301_doDelete'},
    doBrowse: { api: 'M1005CourseTypeService.M20301_doBrowse_AtDataTable'},
  },
}

const module = {
  state: {
    M20301Config: {
      disableAddButton: true
    },
    PageConst,
    searchInfo: {
      course_type: 0,
      search: '',
      delete_flag: 0,
    },
    defaultDoBrowse: {
      searchInfo: {
        course_type: 0,
        search: '',
        delete_flag: 0,
      },
      orderBy: {},
      doBrowseStatus: 'init'
    },
  },

  getters: {},

  mutations: {},

  actions: {
    async M20301_doBrowse_init ({ state, commit, rootState,dispatch }) {

    },
    async M20301_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
